/* 标题的套用 */
// import router from "../../router";
import router from '@/router';



// 设置标题拼接
router.afterEach((to) => {
  // console.log(to)
  if (to.meta && to.meta.title) {
    const title = to.meta.title
    document.title = 'Touch Ortho' + ' - ' + title
  } else {
    document.title = 'Touch Ortho'
  }
})



// 路由设置title
router.beforeEach((to,from,next)=>{3
  // console.log(to)
  // if(to.meta.title)
  // {
  //   document.title=to.meta.title
  // }
  next()
})


// WEBPACK FOOTER //
// ./src/common/js/webTitle.js